// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"348":"47f33483e7742e96","550":"53df90cd0a9253fd","571":"5de23c788c1fad84"}[chunkId] + ".js";
};